import { NgModule } from '@angular/core';
// 一般及第三方匯入
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { PagechangeBtnComponent } from './pagechange-btn.component';
// import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    declarations: [PagechangeBtnComponent],
    imports: [RouterModule, BrowserModule],
    exports: [PagechangeBtnComponent]
})
export class PagechangeBtnModule { }
